import { twResolve } from "@/helpers/tw-resolve";

export interface ProjectLogoProps {
  src: string | undefined;
  shape?: "rounded" | "flushTop";
}

export function ProjectLogo({ src, shape = "rounded" }: ProjectLogoProps): React.ReactNode {
  return (
    <div
      className={twResolve(
        "relative size-full rounded-md border border-border-default bg-background-default object-cover",
        shape === "flushTop" && "rounded-t-none",
      )}
    >
      {src ? (
        <img
          className={twResolve(
            "relative size-full rounded-md object-contain p-space-xs select-none",
            shape === "flushTop" && "rounded-t-none",
          )}
          src={src}
          alt=""
          loading="lazy"
        />
      ) : undefined}
    </div>
  );
}
